import Omnifood from "../../../assets/Images/Hero-Sections/Omnifood.png"
import Forkify from "../../../assets/Images/Hero-Sections/Forkify.png"
import Bankist from "../../../assets/Images/Hero-Sections/Bankist.png"
import Trillo from "../../../assets/Images/Hero-Sections/Trillo.png"
import Natours from "../../../assets/Images/Hero-Sections/Natours-CSS.png"
import Nexter from "../../../assets/Images/Hero-Sections/Nexter.png"
import Specs99 from "../../../assets/Images/Hero-Sections/Specs99.png"
import NatoursMern from "../../../assets/Images/Hero-Sections/Natours.png"



export const projects = [
  {
    title: "Omnifood",
    techStack: ["HTML, ", "CSS/SCSS, ", "JavaScript "],
    timeSpent: "1 Week",
    responsive: true,
    link:"https://lively-kleicha-55527e.netlify.app/",
    image:Omnifood,
    projectDescription:
      "This project was focused on learning best practices with HTML, learning CSS from basics to some advanced technique and after that basics of SASS/SCSS. This project also tought me the techniques to build responsive websites using Grid/Flexbox.",
    conceptsCovered: [
      "HTML fundamentals",
      "CSS fundamentals",
      "Floats",
      "Flexbox",
      "Grids",
      "Web Design Rules",
      "Components Pattern",
      "Layout Patern",
      "Responsive Web Design",
      "Effects & Optimizations"
    ],
  },
  {
    title: "Forkify",
    techStack: ["HTML, ", "CSS/SCSS, ", "JavaScript"],
    timeSpent: "4 Week",
    responsive: false,
    link:"https://quiet-travesseiro-698e66.netlify.app/",
    image:Forkify,
    projectDescription:"This project was focused on learning JavaScript in-depth. It covered almost every concept of JavaScript. The most important concept for me was the OOP, MVC architecture, Advanced DOM, DOM updating algorithm, and asynchronous JavaScript.",
    conceptsCovered: [
      "JS Engine and Runtime",
      "Execution Contexts",
      "The Call Stack",
      "The this Keyword",
      "Primitives vs. Objects",
      "Data Structures",
      "Modern Operators",
      "call, apply and bind",
      "Numbers & Dates",
      "Array Methods"
    ],
  },
  {
    title: "Bankist",
    techStack: ["HTML, ", "CSS/SCSS, ", "JavaScript "],
    timeSpent: "1 Week",
    responsive: false,
    link:"https://magical-paprenjak-e2a068.netlify.app/",
    image:Bankist,
    projectDescription:
      "This project was focused on learning the DOM and DOM events. This project taught me how the DOM works behind the scenes. It covered important concepts like Event Propagation, Event Delegation, DOM Traversing, and The Intersection Observer API",
    conceptsCovered: [
      "Smooth Scrolling",
      "Types of Events",
      "Event Handlers",
      "Bubbling and Capturing",
      "Event Delegation",
      "Passing Arguments to Handlers",
      "The Scroll Event",
      "Lazy Loading Images",
      "Lifecycle DOM Events",
      "Efficient Script Loading"
    ],
  },
  {
    title: "Trillo",
    techStack: ["HTML, ", "CSS/SCSS"],
    timeSpent: "1 Week",
    responsive: true,
    link:"https://magnificent-jelly-c82eb8.netlify.app",
    image:Trillo,
    projectDescription:
      "This project was focused on learning best practices with HTML, learning CSS from basics to some advanced technique and after that basics of SASS/SCSS. This project also tought me the techniques to build responsive websites using Grid/Flexbox.",
    conceptsCovered: [
      "HTML fundamentals",
      "CSS fundamentals",
      "Floats",
      "Flexbox",
      "Grids",
      "Web Design Rules",
      "Components Pattern",
      "Layout Patern",
      "Responsive Web Design",
      "Effects & Optimizations"
    ],
  },
  {
    title: "Natours",
    techStack: ["HTML, ", "CSS/SCSS"],
    timeSpent: "1 Week",
    responsive: true,
    link:"https://kaleidoscopic-mermaid-71cdf7.netlify.app/",
    image:Natours,
    projectDescription:
      "This project was focused on learning best practices with HTML, learning CSS from basics to some advanced technique and after that basics of SASS/SCSS. This project also tought me the techniques to build responsive websites using Grid/Flexbox.",
    conceptsCovered: [
      "HTML fundamentals",
      "CSS fundamentals",
      "Floats",
      "Flexbox",
      "Grids",
      "Web Design Rules",
      "Components Pattern",
      "Layout Patern",
      "Responsive Web Design",
      "Effects & Optimizations"
    ],
  },
  {
    title: "Nexter",
    techStack: ["HTML, ", "CSS/SCSS"],
    timeSpent: "1 Week",
    responsive: true,
    link:"https://harmonious-lamington-202379.netlify.app",
    image:Nexter,
    projectDescription:
      "This project was focused on learning best practices with HTML, learning CSS from basics to some advanced technique and after that basics of SASS/SCSS. This project also tought me the techniques to build responsive websites using Grid/Flexbox.",
    conceptsCovered: [
      "HTML fundamentals",
      "CSS fundamentals",
      "Floats",
      "Flexbox",
      "Grids",
      "Web Design Rules",
      "Components Pattern",
      "Layout Patern",
      "Responsive Web Design",
      "Effects & Optimizations"
    ],
  }
];

export const mernProjects = [
  {
    title: "Specs 99",
    techStack: ["MERN, ", "Stripe, ", "AWS"],
    timeSpent: "2 Month",
    responsive: true,
    link:"https://specs-99.onrender.com/",
    image:Specs99,
    projectDescription:
      "This is an E-commerce project that is capable of doing whatever a E-commerce needs to do. In this project I learned about many new stuffs like AWS s3 bucket, how to store user address on payment by Stripe, and almost everything related to MERN stack.",
    conceptsCovered: [
      "UI/UX",
      "RESTful API",
      "CRUD opertaions",
      "MVC Architecture",
      "Filtering & Sorting data",
      "Aggregation Pipeline",
      "Aggregation Middleware",
      "Data Validation",
      "Error handling with Express",
      "Authentication & Authorization",
      "Security",
      "Server-Side Rendering",
      "File uploads",
      "Image Uploads Using Multer"
    ],
  },
  {
    title: "Natours",
    techStack: ["MERN, ", "Stripe, ", "AWS"],
    timeSpent: "2 Month",
    responsive: true,
    link:"https://github.com/Krishna2323/Natours",
    image:NatoursMern,
    projectDescription:
      "This is a Tour booking project that is capable of doing whatever a Tour booking needs to do. In this project I learned about many new stuffs like using Mapbox for maps with Geospatial Data, how to save and filter images using Multer, and almost everything related to MERN stack. ",
    conceptsCovered: [
      "UI/UX",
      "RESTful API",
      "CRUD opertaions",
      "MVC Architecture",
      "Filtering & Sorting data",
      "Aggregation Pipeline",
      "Aggregation Middleware",
      "Data Validation",
      "Error handling with Express",
      "Authentication & Authorization",
      "Security",
      "Server-Side Rendering",
      "File uploads",
      "Image Uploads Using Multer"
    ],
    notDeployed:true
  },
];
